import { useEffect } from "react";
import { addNewWidgets } from "../../api/dashboard";
import GetSetupFields from "./WidgetSetups_";
import NoSetupWidget from "./WidgetSetups_/noSetupWidget";

import { doesNotNeedSetup, onlySetupTitle } from "src/utils/widgetSetup/needsSetup";
import { shallow } from 'zustand/shallow';
import { useWidgetSetupStore } from "../../context/stores";
import { useTranslation } from 'react-i18next'


const WidgetSetup = ({isCompany, returnToDash, setIsPopupError, setSelectedWidget, setLabelError, dashboardId}) => {
    const [widgetTitle, updateWidgetTitle] = useWidgetSetupStore((state) => [state.widgetTitle, state.updateWidgetTitle],shallow )
    const [setupDetails, updateSetupDetails] = useWidgetSetupStore((state) => [state.setupDetails, state.updateSetupDetails],shallow)
    const [widgetIcon, updateWidgetIcon] = useWidgetSetupStore((state) => [state.widgetIcon, state.updateWidgetIcon],shallow)
    const [selectedWidget, updateSelectedWidget] = useWidgetSetupStore((state) => [state.selectedWidget, state.updateSelectedWidget],shallow)
    const { t } = useTranslation("settings");

    useEffect(() => {
        if(selectedWidget !== ""){
            updateWidgetIcon("")
            updateSetupDetails({})
            updateWidgetTitle("")
        }
    }, [selectedWidget])
    

    const clearForm = () => {
        updateSetupDetails({})
        updateWidgetIcon("")
        updateSelectedWidget("")
        updateWidgetTitle("")

    }

    const submitForm = async(e) => {
        let details={}
        if(!onlySetupTitle.includes(selectedWidget)){
            details = setupDetails
        }

        const request = {
            "dashboard": Number(dashboardId),
            "name": selectedWidget,
            "title": widgetTitle || setupDetails?.title || setupDetails?.measurement?.[0].title|| selectedWidget,
            "setup": JSON.stringify(details),
            "has_popup": false,
            "has_inner_page": false,
            "is_setup": true,
            "is_active": true,
            "is_generate": true,
      }

      try {
        const {data, error} = await addNewWidgets(request)
        if(data){
            clearForm()
            returnToDash()

        }else{
            console.log(error)
            setLabelError(error)
            setIsPopupError(true)
        }
      } catch (error) {
        setLabelError(error)
        setIsPopupError(true)
      }
    }
        
    return ( 
        <section className="flex flex-col w-full h-full gap-2">
            {selectedWidget ===""?
            <div className="h-full overflow-hidden">
                <p className="pb-2 font-semibold border-b ">{t('dashboard_setup.setup_detail')} </p>
                <div className="flex items-center justify-center w-full h-full opacity-50">
                    <p>{t('dashboard_setup.select_message')}</p>
                </div>
            </div>:
            <>
                {isCompany || doesNotNeedSetup.includes(selectedWidget)?
                    <NoSetupWidget selectedWidget={selectedWidget} clearForm={clearForm} submitForm={submitForm}/>
                :
                <>
                    {!isCompany &&
                    <div className="h-full 2xl:w-[80%]">
                        <p className="pb-2 font-semibold border-b">{t('dashboard_setup.setup_detail')} | <span className="font-normal">{selectedWidget}</span></p>
                        {/* -------------------INPUT FIELDS ------------- */}
                        <GetSetupFields submitForm={submitForm} clearForm={clearForm}/>
                    </div> }
                </>
                }   
            </>}
        </section>
     );
}
 
export default WidgetSetup;
